import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="text-xs font-label text-foreground-500 uppercase tracking-wider">探索频道</span>
          <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900 mt-2 leading-tight">
            全网爆料
          </h2>
          <p className="text-2xl md:text-4xl font-heading font-black text-foreground-900 leading-tight">
            一站追踪
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-2xl p-6 md:p-8 hover:bg-background-50 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5 text-foreground-800">
                <i className={`${cat.icon} text-3xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-xs text-primary-500 font-label">
                浏览频道 <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}